import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { Router, RouterLink } from '@angular/router';
import { routes } from '@libs/utils';
import { CollaborationParticipantsComponent } from '../collaboration-participants';
import { CollaborationChatHeaderVM } from './collaboration-chat-header.interface';

@Component({
  selector: 'lib-collaboration-chat-header',
  templateUrl: './collaboration-chat-header.component.html',
  styleUrls: ['./collaboration-chat-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, CollaborationParticipantsComponent, SvgIconComponent, TranslateModule, RouterLink],
})
export class CollaborationChatHeaderComponent {
  private readonly router = inject(Router);

  @Input({ required: true }) public chatHeaderInfo!: CollaborationChatHeaderVM;
  @Input({ required: true }) public participantsString!: string;

  @Output() public openAddParticipantsModal = new EventEmitter<void>();

  protected readonly routes = routes;

  protected onOpenClick(): void {
    this.openAddParticipantsModal.emit();
  }

  protected onNavigateToPatientChart(event: MouseEvent): void {
    event.stopPropagation();
  }
}
